document.addEventListener('DOMContentLoaded', function () {
  var RFQ_EMBED_SUFFIX = '1868344454708136311';
  var TRUST_EMBED_SUFFIX = '2118589882331710876';
  var ETA_EMBED_SUFFIX = '7902831097370503076';

  function textOf(el) {
    return (el && ((el.innerText || el.textContent || el.value || el.getAttribute('aria-label') || '')) || '').trim();
  }

  function escapeHtml(value) {
    if (window.TcbSecurity && window.TcbSecurity.escapeHtml) {
      return window.TcbSecurity.escapeHtml(value);
    }
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function findByEmbedSuffix(suffix) {
    return document.querySelector('[id$="__' + suffix + '"]') ||
      document.querySelector('[id*="' + suffix + '"]');
  }

  function moveToSlot(node, slot) {
    if (!node || !slot || slot.contains(node)) return false;
    if (node.closest('.shopify-section[id*="17816448881f22fae7"]')) return false;
    slot.appendChild(node);
    slot.classList.add('tcb-app-slot--filled');
    return true;
  }

  function ensureInlineStrip() {
    var buyBox = document.querySelector('.tcb-buy-box');
    if (!buyBox) return null;

    var strip = document.getElementById('tcb-buybox-inline');
    if (!strip) {
      strip = document.createElement('div');
      strip.className = 'tcb-buybox-inline';
      strip.id = 'tcb-buybox-inline';
      var anchor = buyBox.querySelector('.tcb-cart-form') || buyBox.querySelector('.tcb-checkout-panel') || buyBox.querySelector('form[action*="/cart/add"]');
      if (anchor && anchor.parentNode === buyBox) {
        anchor.insertAdjacentElement('afterend', strip);
      } else {
        buyBox.appendChild(strip);
      }
    }

    ['tcb-rfq-app-slot'].forEach(function (id) {
      var slot = document.getElementById(id);
      if (!slot) {
        slot = document.createElement('div');
        slot.id = id;
        slot.className = id.replace('tcb-', '').replace('-slot', '-app-slot');
        strip.appendChild(slot);
      } else if (!strip.contains(slot)) {
        strip.appendChild(slot);
      }
    });

    var socialSlot = document.getElementById('tcb-wisernotify-slot');
    if (socialSlot && buyBox && !buyBox.contains(socialSlot)) {
      var upsell = buyBox.querySelector('#tcb-accessory-upsells');
      if (upsell) upsell.insertAdjacentElement('afterend', socialSlot);
      else buyBox.appendChild(socialSlot);
    }

    return strip;
  }

  function hideDuplicateQuoteLinks(buyBox, keepNode) {
    if (!buyBox) return;
    buyBox.querySelectorAll('a, button').forEach(function (el) {
      if (keepNode && (el === keepNode || keepNode.contains(el))) return;
      if (el.closest('#tcb-rfq-app-slot')) return;
      if (el.classList.contains('tcb-quote') && el.closest('#tcb-rfq-app-slot')) return;
      var text = textOf(el).toLowerCase();
      var cls = (el.className || '').toString().toLowerCase();
      var isQuote = text.indexOf('quote') > -1 || cls.indexOf('quote') > -1 || cls.indexOf('rfq') > -1 || cls.indexOf('cfp') > -1;
      if (!isQuote) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-tcb-quote-hidden', '1');
    });
  }

  function findDeliveryNode() {
    var etaApp = findEtaAppNode();
    if (etaApp) return etaApp;

    return Array.prototype.slice.call(document.querySelectorAll(
      '.deliverydate.sb_delivery, .sb_delivery.deliverydate, .shopify-app-block, [class*="leadtime"], [class*="delivery-date"], [class*="delivery_date"], [data-delivery-date], [id*="leadtime"], [id*="delivery-date"], [id*="delivery-date-eta"]'
    )).find(function (el) {
      if (el.closest('.tcb-buybox-inline') || el.closest('#tcb-delivery-app-slot')) return false;
      if (el.closest('.shopify-section[id*="17816448881f22fae7"]')) return false;
      if (el.closest('.sb_info_extension')) return false;
      var html = (el.innerHTML || '').toLowerCase();
      if (html.indexOf('iconic') > -1 || html.indexOf('comparison') > -1) return false;
      var text = textOf(el).toLowerCase();
      var cls = (el.className || '').toString().toLowerCase();
      var id = (el.id || '').toLowerCase();
      if (cls.indexOf('sb_delivery') > -1 || cls.indexOf('deliverydate') > -1) return text.length > 0;
      return (
        text.indexOf('delivery date') > -1 ||
        text.indexOf('expected delivery') > -1 ||
        text.indexOf('estimated delivery') > -1 ||
        text.indexOf('get it by') > -1 ||
        text.indexOf('order today') > -1 ||
        text.indexOf('arrives') > -1 ||
        text.indexOf('receive it') > -1 ||
        cls.indexOf('leadtime') > -1 ||
        cls.indexOf('delivery-date') > -1 ||
        cls.indexOf('delivery_date') > -1 ||
        cls.indexOf('estimated-delivery') > -1 ||
        id.indexOf('leadtime') > -1 ||
        id.indexOf('delivery-date-eta') > -1 ||
        id.indexOf('delivery') > -1
      ) && text.length > 0 && text.length < 520;
    });
  }

  function findEtaAppNode() {
    var embed = findByEmbedSuffix(ETA_EMBED_SUFFIX);
    if (embed && !embed.closest('#tcb-delivery-app-slot')) {
      return embed.querySelector('.deliverydate.sb_delivery, .sb_delivery, .deliverydate') || embed;
    }

    return Array.prototype.slice.call(document.querySelectorAll(
      '.deliverydate.sb_delivery, .sb_delivery.deliverydate, .deliverydate'
    )).find(function (el) {
      if (el.closest('#tcb-delivery-app-slot')) return false;
      if (el.closest('.sb_info_extension')) return false;
      return textOf(el).length > 0;
    });
  }

  function clearEtaFallback(slot) {
    slot.querySelectorAll('.tcb-eta-fallback, .tcb-eta-card--estimated').forEach(function (el) {
      el.remove();
    });
  }

  function mountEtaWidget(node, slot) {
    if (!node || !slot || slot.contains(node)) return false;
    clearEtaFallback(slot);
    var mount = slot.querySelector('.tcb-eta-app-mount') || slot.querySelector('.tcb-eta-app-blocks') || slot;
    mount.appendChild(node);
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    slot.classList.add('tcb-app-slot--filled', 'tcb-eta-card');
    return true;
  }

  function normalizeLeadTime(text) {
    if (!text) return '3 to 8 business days after order confirmation (freight)';
    return String(text)
      .replace(/3\s*[\u2013\u2014-]\s*8/g, '3 to 8')
      .replace(/3\s*â€[\x93\x94]\s*8/gi, '3 to 8')
      .replace(/â€[\x93\x94]/g, ' to ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function normalizeMojibakeText(text) {
    if (!text) return text;
    if (window.tcbNormalizeMojibakeText) return window.tcbNormalizeMojibakeText(text);
    return String(text)
      .replace(/\uFFFD/g, '—')
      .replace(/3\s*\u00e2\u20ac[\u201c\u201d]\s*8/gi, '3 to 8')
      .replace(/3\s*\u00e2\u20ac[\u201c\u201d]8/gi, '3 to 8')
      .replace(/\u00e2\u20ac\u201d/g, '—')
      .replace(/\u00e2\u20ac\u201c/g, '–')
      .replace(/3\s*â€[\x93\x94\u201c\u201d]\s*8/gi, '3 to 8')
      .replace(/3\s*â€[\x93\x94\u201c\u201d]8/gi, '3 to 8')
      .replace(/â€[\x93\x94\u201d]/g, '—')
      .replace(/â€[\x93\x94\u201c]/g, '–')
      .replace(/\u00e2\u20ac\u2122/g, "'")
      .replace(/â€™/g, "'")
      .replace(/\u00e2\u20ac\u2018/g, "'")
      .replace(/â€˜/g, "'")
      .replace(/\u00e2\u20ac\u0153/g, '"')
      .replace(/â€œ/g, '"')
      .replace(/â€[\x9d]/g, '"')
      .replace(/\u00e2\u20ac\u00a6/g, '…')
      .replace(/â€¦/g, '…')
      .replace(/\u00e2\u20ac\u00a2/g, '•')
      .replace(/â€¢/g, '•')
      .replace(/\u00e2\u2044\u2122/g, '™')
      .replace(/â„¢/g, '™')
      .replace(/Ã©/g, 'é')
      .replace(/Ã¨/g, 'è')
      .replace(/Ãª/g, 'ê')
      .replace(/Ã /g, 'à')
      .replace(/Ã¢/g, 'â')
      .replace(/Ã®/g, 'î')
      .replace(/Ã´/g, 'ô')
      .replace(/Ã»/g, 'û')
      .replace(/Ã¼/g, 'ü')
      .replace(/Ã±/g, 'ñ')
      .replace(/Ã—/g, '×')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function fixMojibakeText() {
    document.querySelectorAll(
      '.product-item__title, .product-item__title-link, .product-card__title, .grid-product__title, .card__heading, .tcb-plp-card__title, .tcb-plp-card__title a, .product-meta__title, .product-meta__title a, a[href*="/products/"], .tcb-home-categories__title, h1.product-title, .tcb-buy-box h1, .product-item-meta__title, .featured-collection .product-item__title, [data-section-type="featured-collection"] .product-item__title, [data-section-type="tcb-collection-page"] .tcb-plp-card__title a'
    ).forEach(function (el) {
      var text = textOf(el);
      if (text && (text.indexOf('â€') > -1 || text.indexOf('Ã') > -1 || text.indexOf('\uFFFD') > -1)) {
        el.textContent = normalizeMojibakeText(text);
      }
    });
  }

  function fixLeadTimeText() {
    document.querySelectorAll('#tcb-stock-status span, [data-tcb-lead-time], [data-tcb-eta-value]').forEach(function (el) {
      var attr = el.getAttribute('data-tcb-lead-time');
      if (attr) el.setAttribute('data-tcb-lead-time', normalizeLeadTime(attr));
      var text = textOf(el);
      if (text && (text.indexOf('â€') > -1 || text.indexOf('3-8') > -1 || text.indexOf('3–8') > -1)) {
        el.textContent = normalizeLeadTime(text);
      }
    });
  }

  function readLeadTime() {
    var slot = document.getElementById('tcb-delivery-app-slot');
    if (slot && slot.getAttribute('data-tcb-lead-time')) return normalizeLeadTime(slot.getAttribute('data-tcb-lead-time'));
    var etaValue = document.querySelector('[data-tcb-eta-value]');
    if (etaValue && textOf(etaValue)) return textOf(etaValue);
    var promises = document.querySelectorAll('.tcb-buy-promises div');
    for (var i = 0; i < promises.length; i++) {
      var strong = promises[i].querySelector('strong');
      if (strong && textOf(strong).toLowerCase().indexOf('lead time') > -1) {
        var span = promises[i].querySelector('span');
        if (span && textOf(span)) return textOf(span);
      }
    }
    return '3 to 8 business days after order confirmation (freight)';
  }

  function shippingBlockHtml() {
    return '';
  }

  function readFreightNote() {
    var slot = document.getElementById('tcb-delivery-app-slot');
    if (slot && slot.getAttribute('data-tcb-freight-note')) return slot.getAttribute('data-tcb-freight-note');
    return 'Estimated delivery can change based on inventory, freight carrier, destination, and liftgate or appointment requirements.';
  }

  function ensureEtaCard() {
    var slot = document.getElementById('tcb-delivery-app-slot');
    if (!slot) return;

    slot.classList.add('tcb-eta-card');
    slot.style.setProperty('display', 'grid', 'important');

    var deliveryNode = findDeliveryNode();
    if (deliveryNode && mountEtaWidget(deliveryNode, slot)) return;

    if (slot.querySelector('.deliverydate.sb_delivery, .sb_delivery, .tcb-eta-app-blocks .shopify-app-block')) {
      clearEtaFallback(slot);
      slot.classList.add('tcb-app-slot--filled', 'tcb-eta-card');
      return;
    }

    if (slot.classList.contains('tcb-app-slot--filled') && slot.textContent.trim()) return;
    if (slot.querySelector('.tcb-eta-card--estimated')) return;

    if (!slot.querySelector('[data-tcb-eta-value], .tcb-eta-fallback')) {
      slot.innerHTML =
        '<div class="tcb-eta-fallback tcb-eta-card">' +
          '<strong>Delivery Date / ETA</strong>' +
          '<span data-tcb-eta-value>' + escapeHtml(readLeadTime()) + '</span>' +
          '<small>' + escapeHtml(readFreightNote()) + '</small>' +
          shippingBlockHtml() +
        '</div>';
    }
    slot.classList.add('tcb-app-slot--filled');
  }

  function findTrustBadgeNode() {
    var embed = findByEmbedSuffix(TRUST_EMBED_SUFFIX);
    if (embed && !embed.closest('#tcb-trust-app-slot')) {
      return embed.querySelector('[data-banners]') || embed;
    }
    return document.querySelector('[data-banners]:not(#tcb-trust-app-slot [data-banners])');
  }

  function suppressEssentialUrgencyBanners() {
    var pdp = document.querySelector('.tcb-pro');
    if (!pdp) return;

    var embed = findByEmbedSuffix(TRUST_EMBED_SUFFIX);
    if (embed) {
      embed.style.setProperty('display', 'none', 'important');
      embed.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[data-banners]').forEach(function (node) {
      if (node.closest('#tcb-wisernotify-slot')) return;
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function randomSocialCount(min, max, salt) {
    min = min || 50;
    max = max || 99;
    var span = max - min + 1;
    return min + Math.floor(Math.random() * span);
  }

  function socialProofHtml(viewers, carts, stock) {
    return (
      '<div class="tcb-social-proof tcb-social-proof--app" data-tcb-social-proof role="status">' +
        '<span class="tcb-social-proof-icon" aria-hidden="true">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M6 6h15l-1.5 9h-12L6 6z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
            '<circle cx="9" cy="20" r="1.5" fill="currentColor"/><circle cx="17" cy="20" r="1.5" fill="currentColor"/>' +
            '<path d="M6 6L5 3H2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
          '</svg><span class="tcb-social-proof-badge">!</span></span>' +
        '<p class="tcb-social-proof-copy tcb-social-proof-copy--oneline"><strong>Other people want this.</strong>' +
          '<span class="tcb-social-proof-line" data-tcb-viewers>' + viewers + ' Visitors are viewing this item</span>' +
          '<span class="tcb-social-proof-line" data-tcb-carts>Over ' + carts + ' people have this in their carts now.</span>' +
          '<span class="tcb-social-proof-line" data-tcb-stock>' + stock + ' Items left!</span>' +
        '</p></div>'
    );
  }

  function updateSocialProofCounts(proof) {
    if (!proof) return;
    var viewers = randomSocialCount(50, 99, 1);
    var carts = randomSocialCount(50, 99, 2);
    var stock = randomSocialCount(50, 99, 3);
    while (carts === viewers) carts = randomSocialCount(50, 99, 4);
    while (stock === viewers || stock === carts) stock = randomSocialCount(50, 99, 5);
    var viewersEl = proof.querySelector('[data-tcb-viewers]');
    var cartsEl = proof.querySelector('[data-tcb-carts]');
    var stockEl = proof.querySelector('[data-tcb-stock]');
    if (viewersEl) viewersEl.textContent = viewers + ' Visitors are viewing this item';
    if (cartsEl) cartsEl.textContent = 'Over ' + carts + ' people have this in their carts now.';
    if (stockEl) stockEl.textContent = stock + ' Items left!';
  }

  function isUrgencySpam(text) {
    var t = (text || '').toLowerCase();
    return (
      t.indexOf('items left') > -1 ||
      t.indexOf('10000') > -1 ||
      t.indexOf('visitors are viewing') > -1 ||
      t.indexOf('visitor are viewing') > -1
    );
  }

  function isOurSocialProof(el) {
    return !!(el && el.closest('#tcb-wisernotify-slot [data-tcb-social-proof]'));
  }

  function purgeUrgencySpam() {
    var slot = document.getElementById('tcb-wisernotify-slot');
    var roots = [document.querySelector('.tcb-pro'), document.body];
    roots.forEach(function (root) {
      if (!root) return;
      Array.prototype.slice.call(root.querySelectorAll('*')).forEach(function (el) {
        if (isOurSocialProof(el)) return;
        if (slot && slot === el) return;
        if (slot && slot.contains(el) && !el.closest('[data-tcb-social-proof]')) {
          var inner = textOf(el).toLowerCase();
          if (inner.indexOf('items left') > -1 || inner.indexOf('10000') > -1) {
            el.style.setProperty('display', 'none', 'important');
            el.setAttribute('data-tcb-urgency-hidden', '1');
          }
          return;
        }
        if (isOurSocialProof(el)) return;
        var text = textOf(el);
        if (text.length > 200 || text.length < 6) return;
        if (!isUrgencySpam(text)) return;
        if (el.querySelector('[data-tcb-social-proof]')) return;
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('data-tcb-urgency-hidden', '1');
      });
    });
  }

  function normalizeSocialProofSlot(slot) {
    if (!slot) return;
    var proof = slot.querySelector('[data-tcb-social-proof]');
    if (!proof) {
      var viewers = randomSocialCount(10, 99, 1);
      var carts = randomSocialCount(10, 99, 2);
      var stock = randomSocialCount(10, 99, 3);
      while (carts === viewers) carts = randomSocialCount(10, 99, 4);
      while (stock === viewers || stock === carts) stock = randomSocialCount(10, 99, 5);
      slot.innerHTML = socialProofHtml(viewers, carts, stock);
      slot.classList.add('tcb-app-slot--filled', 'tcb-app-slot--fallback');
      return;
    }
    if (!proof.querySelector('[data-tcb-viewers]') || !proof.querySelector('[data-tcb-carts]') || !proof.querySelector('[data-tcb-stock]')) {
      updateSocialProofCounts(proof);
    }
    Array.prototype.slice.call(slot.children).forEach(function (child) {
      if (child.matches('[data-tcb-social-proof]')) return;
      if (isUrgencySpam(textOf(child))) child.remove();
    });
  }

  function formatSocialProofSlot(slot) {
    normalizeSocialProofSlot(slot);
  }

  function relocateTrustBadges() {
    suppressEssentialUrgencyBanners();
  }

  function findSocialProofNode() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[class*="wisernotify"], [id*="wisernotify"], [data-wisernotify], .wn-social-proof, .tcb-viewing-widget:not(#tcb-wisernotify-slot .tcb-viewing-widget)'
    )).find(function (el) {
      if (el.closest('#tcb-wisernotify-slot')) return false;
      if (el.closest('.shopify-section[id*="17816448881f22fae7"]')) return false;
      return textOf(el).length > 0;
    });
  }

  function ensureSocialFallback(slot) {
    if (!slot || slot.querySelector('[data-tcb-social-fallback]')) {
      if (slot && !slot.textContent.trim()) slot.classList.add('tcb-app-slot--filled', 'tcb-app-slot--fallback');
      return;
    }
    if (slot.textContent.trim() && slot.classList.contains('tcb-app-slot--filled') && !slot.querySelector('[data-tcb-social-fallback]')) return;
    slot.classList.add('tcb-app-slot--filled', 'tcb-app-slot--fallback');
  }

  function relocateSocialProof() {
    var slot = document.getElementById('tcb-wisernotify-slot');
    if (!slot) return;
    purgeUrgencySpam();

    var external = findSocialProofNode();
    if (external) {
      external.style.setProperty('display', 'none', 'important');
      external.setAttribute('data-tcb-urgency-hidden', '1');
    }

    normalizeSocialProofSlot(slot);
    purgeUrgencySpam();
  }

  function relocateRfqButton() {
    var buyBox = document.querySelector('.tcb-buy-box');
    var slot = document.getElementById('tcb-rfq-app-slot');
    if (!slot) return;

    if (!slot.querySelector('.tcb-rfq-helper')) {
      var helper = document.createElement('p');
      helper.className = 'tcb-rfq-helper';
      helper.textContent = 'Need a better delivered price or accessory bundle? Request a quote before ordering.';
      slot.insertBefore(helper, slot.firstChild);
    }

    var embed = findByEmbedSuffix(RFQ_EMBED_SUFFIX);
    if (embed && !slot.contains(embed)) {
      moveToSlot(embed, slot);
    }

    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      'a[class*="cfp"], button[class*="cfp"], .cfp-button, .sb-rfq-button, [class*="call-for-price"], [class*="request-a-quote"], [id*="call-for-price"], [data-sb-rfq], .sb-rfq-compact-btn, .sb-rfq-multi-step-btn'
    )).filter(function (el) {
      if (slot.contains(el)) return false;
      if (el.closest('.shopify-section[id*="17816448881f22fae7"]')) return false;
      if (el.getAttribute('data-tcb-quote-hidden') === '1') return false;
      var text = textOf(el).toLowerCase();
      return text.indexOf('quote') > -1;
    });

    var primary = candidates[0];
    if (primary && !slot.contains(primary)) {
      var helperNode = slot.querySelector('.tcb-rfq-helper');
      slot.innerHTML = '';
      if (helperNode) slot.appendChild(helperNode);
      slot.appendChild(primary);
      primary.style.setProperty('display', 'flex', 'important');
      primary.style.setProperty('visibility', 'visible', 'important');
      primary.style.setProperty('opacity', '1', 'important');
      primary.style.setProperty('width', '100%', 'important');
      primary.classList.add('tcb-primary-rfq');
    }

    hideDuplicateQuoteLinks(buyBox, primary || slot.querySelector('.tcb-primary-rfq, .sb-rfq-button, .cfp-button'));
  }

  function wrapAppBlocks() {
    var appsSection = document.querySelector('.shopify-section[id*="17816448881f22fae7"]');
    if (!appsSection) return;
    appsSection.querySelectorAll('.shopify-app-block').forEach(function (block) {
      var html = block.innerHTML.toLowerCase();
      if (block.dataset.tcbWrapped) return;
      if (html.indexOf('jdgm-rev-widg') > -1 || html.indexOf('judgeme_widget') > -1) {
        block.dataset.tcbWrapped = '1';
        if (!document.getElementById('tcb-reviews-section')) block.id = 'tcb-reviews-section';
      } else if (html.indexOf('iconic') > -1 || html.indexOf('comparison') > -1) {
        block.dataset.tcbWrapped = '1';
        if (!document.getElementById('tcb-comparison-section')) block.id = 'tcb-comparison-section';
      }
    });
  }

  function runAll() {
    ensureInlineStrip();
    fixLeadTimeText();
    fixMojibakeText();
    relocateRfqButton();
    ensureEtaCard();
    suppressEssentialUrgencyBanners();
    purgeUrgencySpam();
    relocateSocialProof();
    wrapAppBlocks();
  }

  runAll();
  [400, 900, 1800, 3500, 6000, 10000, 15000, 22000].forEach(function (ms) { setTimeout(runAll, ms); });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () { runAll(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 45000);
  }

  document.addEventListener('tcb:variant-change', function () {
    setTimeout(runAll, 200);
  });
});
